var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnreadDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11 22C17.0177 22 22 17.0069 22 11C22 4.98235 17.0069 0 10.9892 0C4.98235 0 0 4.98235 0 11C0 17.0069 4.99313 22 11 22ZM11 20.1666C5.90979 20.1666 1.84411 16.0902 1.84411 11C1.84411 5.90979 5.89902 1.83334 10.9892 1.83334C16.0793 1.83334 20.1666 5.90979 20.1666 11C20.1666 16.0902 16.0902 20.1666 11 20.1666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81371 16.1225C10.1696 16.1225 10.4716 15.95 10.6872 15.6157L15.6156 7.86177C15.7342 7.64609 15.8745 7.40883 15.8745 7.17158C15.8745 6.68629 15.4431 6.37354 14.9902 6.37354C14.7206 6.37354 14.4509 6.54608 14.2461 6.85884L9.77058 14.0411L7.64607 11.2912C7.38724 10.9461 7.14999 10.8598 6.84803 10.8598C6.3843 10.8598 6.01764 11.2373 6.01764 11.7118C6.01764 11.949 6.1147 12.1755 6.26568 12.3804L8.89704 15.6157C9.16665 15.9716 9.45783 16.1225 9.81371 16.1225Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7117 20.3C22.0981 20.6823 22.0981 21.3426 21.6996 21.7133C21.289 22.0956 20.6248 22.0956 20.2263 21.7133L0.288338 1.69567C-0.0981029 1.32497 -0.0981031 0.676248 0.300419 0.282385C0.69893 -0.0999007 1.37521 -0.0883112 1.77372 0.282385L21.7117 20.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadDisabledIcon);
export default __webpack_public_path__ + "static/media/unread_disabled_icon.409fd9c7ff3cc55bea6198833b80b9db.svg";
export { ForwardRef as ReactComponent };